<template lang="pug">
  .row
    .col-sm-12
      #wrapper(:class='{mlft8: isMobiled, mlft25: !isMobiled}')
        #dialog
          #form
            div(
              v-for='(key, index) in lists', :key='`input${index}`',
              style="float: left; width: 30px; height: 72px;margin: 10px 5px;"
            )
              input.input-items.form-control(
                type='text',
                ref='input_item',
                @keyup='autoTab($refs.input_item[index], 1, $event)',
                maxlength='1',
                v-model="code[key]"
                @keydown.prevent.tab.exact='moveNext',
                @keydown.prevent.shift.tab='movePrev',
                @keydown.prevent.down='moveNext',
                @keydown.prevent.up='movePrev'
              )
    .col-sm-12
      button.btn.btn-primary.btn-round.waves-effect.w100(
        type='button',
        @click.prevent="doActive()") Confirmar
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import bus from '@/utils/eventBus'

  export default {
    data () {
      return {
        code: [],
        isCodeNull: false,
        num: 6,
        isMobiled: false
      }
    },
    props: {
      schedule: {
        type: Object,
        required: true
      }
    },
    methods: {
      doActive () {
        if (this.code.length <= 0) {
          this.isCodeNull = true
          this.$toast.warning('Você precisa informar o código de ativação.')
          return
        }
        this.loading = true
        const params = {
          id: this.schedule.id,
          code: this.code.join('')
        }
        this.$http.post('/v1/dweller/scheduled/confirmed', params)
          .then(({data, meta}) => {
            if (data.confirmed) {
              bus.$emit('schedule-actived', {show: true, msg: meta})
            } else {
              bus.$emit('do-not-exist', {show: true, msg: meta})
            }
          })
          .catch(({data, meta}) => {
            bus.$emit('do-not-exist', {show: true, msg: meta})
          })
      },
      autoTab (input, len, e) {
        var vm = this
        const index = vm.findIndex(e.target)
        if (input.value.length >= len) {
          vm.moveFocus(index + 1)
        }
      },
      findIndex (target) {
        return [].findIndex.call(this.elements, e => e === target)
      },
      moveFocus (index) {
        if (this.elements[index]) {
          this.elements[index].focus()
        }
      },
      moveNext (event) {
        const index = this.findIndex(event.target)
        this.moveFocus(index + 1)
      },
      movePrev (event) {
        const index = this.findIndex(event.target)
        this.moveFocus(index - 1)
      }
    },
    computed: {
      lists () {
        return Array.from(Array(this.num).keys())
      },
      elements () {
        return document.getElementsByClassName('input-items')
      }
    },
    mounted () {
      if (isMobile) {
        this.isMobiled = true
      }
    }
  }
</script>
<style scoped>
.w100 {
  width: 100%;
}
.mlft25 {
  margin-left: 15%;
}
.mlft8 {
  margin-left: 5%;
}
.form-control {
  display: block;
  width: 100%;
  padding: .002rem .1rem; */
  font-size: 1rem;
  line-height: 1.0;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
#wrapper {
  font-family: Lato;
  font-size: 1.5rem;
  text-align: center;
  box-sizing: border-box;
  color: #333;
}
#wrapper #dialog {
  width: 100%;
  margin: 10px auto;
  display: inline-block;
  overflow: hidden;
  position: relative;
}

#wrapper #dialog span {
  font-size: 90%;
}
#wrapper #dialog #form {
  max-width: 300px;
  margin: 25px auto 0;
}
#wrapper #dialog #form input {
  text-align: center;
  font-size: 30px;
  border: solid 1px #ccc;
  box-shadow: 0 0 5px #ccc inset;
  transition: all 0.2s ease-in-out;
  border-radius: 3px;
}
#wrapper #dialog #form input:focus {
  border-color: purple;
  box-shadow: 0 0 5px purple inset;
}
#wrapper #dialog #form input::selection {
  background: transparent;
}
#wrapper #dialog #form button {
  margin: 30px 0 50px;
  width: 100%;
  padding: 6px;
  background-color: #7159c1;
  border: none;
  text-transform: uppercase;
}

#wrapper #dialog div {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/nexts/resources/active.vue